import React, { useState } from 'react'
import { App, } from 'antd'
import { useDingdanshouruCWCHMutation, } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'   
import dayjs from 'dayjs'
function IncomeFinanceWithdraw(props) {    
    const {message,modal} = App.useApp()
    const [cwch] = useDingdanshouruCWCHMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const content = props.ddsr_cw_content ? props.ddsr_cw_content + `！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：收款单取消提交` : `${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：收款单取消提交`
    const handleCWCH = () => {
        // 如果正在提交中，直接返回
        if (isSubmitting) {
            return;
        }
        
        // 设置提交状态
        setIsSubmitting(true);
        
       modal.confirm({
        title: '确认要取消这个收款单的提交吗？',
        content: '财务取消提交后，收款单将退回到待提交状态，计调修改后重新提交。',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
            cwch({
                ddsr_id:props.ddsr_id,
                ddsr_state: '1',
                ddsr_cw_content:content,
                ddsr_amount:props.ddsr_amount,
            }).then((res) => {
                if(res.data.Status === 'success') {
                    message.success('收款单取消提交成功！')
                if (props.onSuccess && typeof props.onSuccess === 'function') {
                    props.onSuccess();
                }
                }else{
                    message.error('收款单取消提交失败！'+res.data.Message)
                }
                // 3秒后恢复可点击状态
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
            }).catch((err) => {
                // 出错时也要恢复状态
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
            })
        },
        onCancel: () => {
            setIsSubmitting(false);
        }
       })
    }    
    return (
        <Icon 
            type='withdraw' 
            onClick={() => handleCWCH()} 
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        />
    )
}

export default IncomeFinanceWithdraw